import * as React from 'react'

import Svg, { Path } from 'react-native-svg'

import { IconProps } from '..'

const TopAgentCustomerOutline = ({
  size = 24,
  color = '#000',
  ...props
}: IconProps) => {
  return (
    <Svg
      width={`${size}px`}
      height={`${size}px`}
      viewBox="0 0 24 24"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.516 11.046a3.757 3.757 0 003.754-3.754 3.75 3.75 0 00-3.754-3.754 3.75 3.75 0 00-3.754 3.754 3.75 3.75 0 003.754 3.754zm0-5.925a2.18 2.18 0 012.181 2.181 2.18 2.18 0 01-2.181 2.181 2.18 2.18 0 01-2.181-2.18A2.18 2.18 0 019.516 5.12zm12.583 10.696a1.5 1.5 0 00.44-1.531c-.168-.608-.671-1.049-1.321-1.164-.535-.094-1.07-.189-1.605-.273-.052 0-.104-.042-.125-.094l-.182-.362a61.908 61.908 0 01-.542-1.096c-.273-.555-.807-.901-1.405-.901s-1.132.346-1.405.901l-.362.73c-.12.243-.24.487-.362.728-.02.052-.073.084-.125.094-.292.052-.583.1-.877.149-.245.04-.49.081-.738.124a1.646 1.646 0 00-1.31 1.164c-.158.566 0 1.132.429 1.52.388.357.776.724 1.164 1.09.031.032.052.085.042.127a40.743 40.743 0 00-.2 1.583c-.062.608.231 1.216.766 1.573a1.6 1.6 0 00.891.283c.231 0 .462-.052.671-.168.088-.044.175-.09.263-.135.367-.19.747-.385 1.195-.588.44.24.881.47 1.303.692l.06.031c.493.252 1.08.21 1.573-.115.535-.357.818-.965.765-1.583a40.57 40.57 0 00-.185-1.48l-.014-.104c0-.042.01-.084.042-.126l.054-.05c.371-.352.75-.71 1.11-1.04l-.01.02zm-2.17.031c-.378.367-.567.881-.494 1.395.074.514.137 1.017.189 1.52a.24.24 0 01-.073.168c-.053.052-.105.073-.126.073-.44-.23-.892-.471-1.342-.713a1.571 1.571 0 00-1.489 0 88.57 88.57 0 01-1.343.713s-.073-.01-.125-.073a.24.24 0 01-.074-.168c.053-.503.116-1.017.2-1.53a1.587 1.587 0 00-.493-1.395l-.134-.127a15.892 15.892 0 01-1.051-1.058.236.236 0 01.146-.095c.535-.094 1.07-.188 1.594-.272.514-.084.955-.42 1.196-.88.251-.494.493-.987.734-1.48.01-.03.042-.083.084-.083s.073.052.084.084c.24.493.482.985.733 1.478.231.462.682.797 1.196.88.465.074.922.155 1.384.236l.21.037c.094.021.136.063.146.168-.387.357-.786.734-1.184 1.112l.031.01zm-9.186-2.674h-4.53l-.01-.01c-.913-.063-1.783.293-2.423.933-.629.64-.964 1.5-.912 2.37v1.96c0 .116.031.21.105.284.073.073.147.105.272.105h7.508a.73.73 0 01.734.734.73.73 0 01-.734.734H3.235c-.482 0-.944-.189-1.29-.535a1.853 1.853 0 01-.535-1.332V16.52c-.073-1.237.42-2.506 1.343-3.439a4.644 4.644 0 013.502-1.374h4.488a.73.73 0 01.734.734.73.73 0 01-.734.734z"
        fill={color}
      />
    </Svg>
  )
}

export default TopAgentCustomerOutline
